export const DISPERSION_METHOD_COMPONENTS_CONSTANT = Object.freeze({
  VERIFICATION_SELECT_ACCOUNT: 'VERIFICATION_SELECT_ACCOUNT',
  DISPERSION_SELECT_OPTION: 'DISPERSION_SELECT_OPTION',
  ALTERNATIVE_OPTION: 'ALTERNATIVE_OPTION',
  GRAY_ZONE: 'GRAY_ZONE',
  LOAN_APPLICATION_REJECTED: 'LOAN_APPLICATION_REJECTED',
  LOAN_APPLICATION_CANCELED: 'LOAN_APPLICATION_CANCELED',
  CARD_APPLICATION: 'CARD_APPLICATION',
  REFERENCES: 'REFERENCES',
});

export const DEFAULT_PROCESS_ID_CONSTANT = '1';
